





























import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import '@/extensions';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import {
    IModuleItemResponseDto,
    IModuleItemTableItem,
    TModuleType
} from "@/pages/ModuleItems/data";
import ModuleApi from "@/pages/ModuleItems/ModuleApi";
import mermaid from 'mermaid';
import {Promotions, Sales} from "@/interfaces/global-data";

@Component({
    components: {
        vSelect,
        CollapseCard,
        Card,
    },
})

export default class ItemsListGanttDiagram extends Mixins(LocalData, Http) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: true}) readonly api!: ModuleApi;

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    mounted() {
        this.isDiagramLoading = true;

        mermaid.initialize({
            startOnLoad: true,
            securityLevel: 'loose'
        });

        mermaid.ganttConfig = {
            // titleTopMargin: 0, // Margin top for the text over the diagram
            // barHeight: 25, // The height of the bars in the graph
            // barGap: 6, // The margin between the different activities in the gantt diagram
            // topPadding: 20, // Margin between title and gantt diagram and between axis and gantt diagram.
            // bottomPadding: 40, // Margin between title and gantt diagram and between axis and gantt diagram.
            // rightPadding: 20, // The space allocated for the section name to the right of the activities
            // leftPadding: 20, // The space allocated for the section name to the left of the activities
            // gridLineStartPadding: 16, // Vertical starting position of the grid lines
            // fontSize: 13, // Font size
            // sectionFontSize: 10, // Font size for sections
            // numberSectionStyles: 1, // The number of alternating section styles
            // axisFormat: '%d/%m', // Date/time format of the axis
            tickInterval: '1day', // Axis ticks
            topAxis: true, // When this flag is set, date labels will be added to the top of the chart
            // displayMode: "", // Turns compact mode on
            // weekday: 'sunday', // On which day a week-based interval should start
        };

        this.$nextTick(() => {
            this.fetchItems();
        });
    }

      @Watch('itemsForDiagram', {deep: true})
      regenerateDiagram() {
          this.generateGanttDiagram();
      }

      @Watch('ganttDiagram')
      renderMermaid() {
        this.$nextTick(() => {
            this.diagramKey++;

            this.$nextTick(() => {
                mermaid.contentLoaded();

                this.addClickListeners();
            });
        })
      }

    private ganttDiagram: string = '';
    private diagramKey: number = 1;
    private isDiagramLoading: boolean = true;
    private isModuleItemLoading: boolean = false;
    private itemsForDiagram: Array<IModuleItemResponseDto> = [];
    private ganttContainerWidth: string = '100%';
    private ganttContainerHeight: string = '30vh';

    private getDaysCount(ranges: Array<IModuleItemResponseDto>): number {
        const { minDate, maxDate } = ranges.reduce<{
            minDate: Date | null;
            maxDate: Date | null;
        }>((acc, { startDate, endDate }) => {
            const start = new Date(startDate as string);
            const end = new Date(endDate as string);

            if (!acc.minDate || start < acc.minDate) {
                acc.minDate = start;
            }

            if (!acc.maxDate || end > acc.maxDate) {
                acc.maxDate = end;
            }

            return acc;
        }, { minDate: null, maxDate: null });

        if (!minDate || !maxDate) {
            return 0;
        }

        const timeDiff = maxDate.getTime() - minDate.getTime(); // in milliseconds
        return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    }

    private generateGanttDiagram() {
        const tasks = this.itemsForDiagram.map(item => {
            return `${(this.getItemTypeLabel(item.type) + '#46; ' + item.name).trim()} :${item.id}, ${item.startDate}, ${item.endDate}`;
        }).join('\n');

        const daysCount = this.getDaysCount(this.itemsForDiagram);

        this.ganttContainerWidth = daysCount > 80 ? daysCount * 20 + 'px' : '100%';
        this.ganttContainerHeight = this.itemsForDiagram.length * 25 + 100 + 'px';

        this.ganttDiagram = `gantt\ndateFormat  YYYY-MM-DD\n${tasks}`;
    }

    addClickListeners() {
        this.$nextTick(() => {
            const tasks = document.querySelectorAll('.task');
            const taskTexts = document.querySelectorAll('.taskText');

            tasks.forEach(task => {
                task.addEventListener('click', (event) => {
                    if (event.currentTarget) {
                        const itemId = (event.currentTarget as HTMLElement).getAttribute('id');
                        this.handleItemClick(itemId as string);
                    }
                });
            });

            taskTexts.forEach(taskText => {
                taskText.addEventListener('click', (event) => {
                    if (event.currentTarget) {
                        const itemId = (event.currentTarget as HTMLElement).getAttribute('id');
                        this.handleItemClick((itemId as string).replace('-text', ''));
                    }
                });
            });
        });
    }

    handleItemClick(itemId: string) {
        // TODO here will request to server for fetch single Item as for table by id - after adding route on Backend
        // next - temporary, emulation
        this.isModuleItemLoading = true;

        setTimeout(() => {
            const item = this.itemsForDiagram.find(itemObj => itemObj.id === Number(itemId));

            this.isModuleItemLoading = false;

            this.$emit('open-params-tab', item);
        }, 500)
    }

     fetchItems() {
        if (!this.moduleData.selectMarket.id) {
            return;
        }

        this.isDiagramLoading = true;

        const usualParams = {
          page: 0,
          size: 1000,
          tradingId: this.moduleData.selectMarket.id,
        };

        this.api.fetchItems(this.moduleType, usualParams)
            .then((resp) => {
                if (resp.status === 200) {
                    const array: IModuleItemTableItem[] = [];

                    resp.data.content.forEach((e: IModuleItemResponseDto) => {
                        array.push({
                            id: e.id,
                            tradingId: e.tradingId,
                            groups: e.groups,
                            categories: e.categories,
                            subcategory: e.subcategory,
                            clusters: e.clusters,
                            format: e.format,
                            regions: e.regions,
                            status: e.status,
                            type: e.type,
                            skuCount: e.skuCount,
                            remains: e.remains,
                            taskId: e.taskId,
                            startDate: e.startDate,
                            endDate: e.endDate,
                            name: e.name,
                            stagesNumber: e.stagesNumber,
                            minSaleDiscount: e.minSaleDiscount,
                            maxSaleDiscount: e.maxSaleDiscount,
                            minPromotionDiscount: e.minPromotionDiscount,
                            maxPromotionDiscount: e.maxPromotionDiscount,
                            minMargin: e.minMargin,
                            considerPlannedSeason: false, // временно, после доработок по бэку убрать and uncomment below
                            revaluationFileName: e.revaluationFileName, // временно, после доработок по бэку убрать and uncomment below
                            // considerPlannedSeason: e.considerPlannedSeason,
                        })
                    })

                    this.itemsForDiagram = Object.assign([], array);

                    this.isDiagramLoading = false;
                }
            })
            .catch((e) => {
                this.showError(this.$t('shared.itemsList.errorLoadGantt', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameGen') as string : this.$t('sales.typeNameGen') as string }) as string);
                console.error(e);
            });
    }

    getItemTypeLabel(typeValue: string | null = null) {
        const typeObj = this.moduleItemTypeOptions[this.moduleType].find(option => option.value === typeValue);

        return typeObj ? typeObj.label : this.$t('shared.labels.unknownType') as string;
    }
}

